import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";

import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtART from "./CustomTool/ResponsiveTable";
// import { fetchSite } from "./API";
import CtCmb from "./CustomTool/CtCmb";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import { fetchSite } from "./API";

class SiteMaster extends Component {
  state = {
    BranchList: [],

    SiteList: [],
    columnsdata: [
      {
        header: "Branch Code",
        accessorKey: "vac_brcode",
        size: 100,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "Branch Name",
        accessorKey: "vac_brname",
        size: 100,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "Site Code",
        accessorKey: "bint_srno",
        size: 100,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "Site Name",
        accessorKey: "vac_sitename",
        size: 200,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },

      {
        header: "Site Address",
        accessorKey: "vac_siteaddress",
        size: 250,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
    ],

    rows: [],
    formData: {
      bint_srno: 0,
      // txtBranchCode: "",
      cmbBranchName: "",
      cmbsiteName: "",
      txtsiteAddress: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "Site Master");
    this.props.verifyUserID(
      this.getInfo,
      this.props.setUserPrivileges,
      this.props.modules.client,
    );
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.saveSite,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.cmbsiteName,
        );
      },
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_srno",
      "vac_brcode",
      "vac_brname",
      "vac_sitename",
      "vac_siteaddress",
    ]);
    const bint_srno = row.bint_srno,
      // txtBranchCode = row.vac_sitename,
      txtsiteAddress = row.vac_siteaddress,
      cmbBranchName = row.vac_brname,
      cmbsiteName = row.vac_sitename;
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        // txtBranchCode,
        txtsiteAddress,
        cmbBranchName,
        cmbsiteName,
      },
    });
    document.getElementById("cmbBranchName").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_sitename"]);
    this.DeleteData(row.bint_srno, row.vac_sitename);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListSiteMaster",
      vac_userid: localStorage.getItem("vac_userid"),
    };
    fetchSite(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.SiteList,
          BranchList = res.data.BrNameList,
          SiteList = res.data.SiteNameData,
          rowsCount = rows.length;

        this.setState({
          rowsCount,
          SiteList,
          BranchList,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("cmbBranchName").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          // txtBranchCode: "",
          cmbBranchName: "",
          cmbsiteName: "",
          txtsiteAddress: "",
        },
      },
      () => {
        document.getElementById("cmbBranchName").focus();
      },
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationSite = () => {
    let result = false;
    // if (this.state.formData.txtBranchCode.length <= 0) {
    //   this.props.toastErrorMsg("Enter Branch Code", "txtBranchCode");
    // }
    //  else
    if (this.state.formData.cmbBranchName.length <= 0) {
      this.props.toastErrorMsg("Enter Branch Name", "cmbBranchName");
    } else if (this.state.formData.cmbsiteName.length <= 0) {
      this.props.toastErrorMsg("Enter Site Name", "cmbsiteName");
    } else if (this.state.formData.txtsiteAddress.length <= 0) {
      this.props.toastErrorMsg("Enter Site Address", "txtsiteAddress");
    } else {
      result = true;
    }
    return result;
  };

  saveSite = () => {
    if (this.validationSite()) {
      this.props.notifyProcessing();
      const reqData = {
        Op: "SaveSiteMaster",
        bint_srno: this.state.formData.bint_srno || 0,
        // vac_brcode: this.state.formData.txtBranchCode,
        vac_brname: this.state.formData.cmbBranchName,
        vac_sitename: this.state.formData.cmbsiteName,
        vac_siteaddress: this.state.formData.txtsiteAddress,
      };
      fetchSite(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            let rows = [],
              SiteList = res.data.SiteNameData,
              rowsCount = rows.length;
            if (res.data.SiteList && res.data.SiteList.length > 0) {
              rows = res.data.SiteList;
              rowsCount = rows.length;
            }
            this.setState(
              {
                rows,
                rowsCount,
                SiteList,
              },
              () => {
                this.clearInfo();
              },
            );
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in Save Client .", error);
        });
    }
  };

  DeleteData = (bint_srno, vac_sitename) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete  : ${vac_sitename} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteSite(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteSite = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteSiteMaster",
      bint_srno: bint_srno,
    };
    fetchSite(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.SiteList && res.data.SiteList.length > 0) {
            rows = res.data.SiteList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Lop Price. " + error,
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveSite}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.cmbsiteName,
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          {/* <Grid item>
            <CtTxt
              id="txtBranchCode"
              label="Branch Code*"
              value={this.state.formData.txtBranchCode}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"cmbBranchName"}
            />
          </Grid> */}
          <Grid item>
            <CtCmbEditable
              id="cmbBranchName"
              label="Branch Name*"
              value={this.state.formData.cmbBranchName}
              handleOnChange={this.handleOnChange}
              width={220}
              items={this.state.BranchList}
              colID="vac_brname"
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"cmbsiteName"}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbsiteName"
              label="Site Name*"
              value={this.state.formData.cmbsiteName}
              items={this.state.SiteList}
              colID="vac_sitename"
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtsiteAddress"}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtMultiLineText
              id="txtsiteAddress"
              label="Site Address*"
              value={this.state.formData.txtsiteAddress}
              handleOnChange={this.handleOnChange}
              width={420}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.saveSite}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("Site Master")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={50}
              density={"compact"}
              hideColIdList={["vac_brcode", "vac_brname"]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <SiteMaster {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
